// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"e7038623","79":"965b0fc8","109":"ad204922","185":"7173b127","285":"7c567a04","647":"e479aeba","974":"4ff47313"}[chunkId] + ".js";
};